import { Label, LabelProps, PanelProps } from "@mcleod/components";
import { AbstractLinePanel } from "./AbstractLinePanel";
import { FinalizedExample } from "./FinalizedExample";

export class PropertyLinePanel extends AbstractLinePanel {
    constructor(propName: string, propDef: any, examples: FinalizedExample[],
        props?: Partial<PanelProps>) {
        super(propName, propDef, examples, props);
    }

    protected override build(propName?: string, propDef?: any) {
        const labelName = new Label({ ...this.getNameColumnDef(propName) });
        this.add(labelName);
        const labelType = new Label({ ...this.getTypeColumnDef(propDef?.type) });
        this.add(labelType);
        const labelDefaultValue = new Label({ ...this.getDefaultValueColumnDef(propDef?.defaultValue) });
        this.add(labelDefaultValue);
        const labelDescr = new Label({ ...this.getDescrColumnDef(propDef?.description) });
        this.add(labelDescr);
    }

    protected getNameColumnDef(text: string = ""): Partial<LabelProps> {
        return { text, width: 220, fontBold: true };
    }

    protected getTypeColumnDef(text: string = ""): Partial<LabelProps> {
        return { text, width: 100 };
    }

    protected getDefaultValueColumnDef(text: string = ""): Partial<LabelProps> {
        return { text, width: 140 };
    }

    protected getDescrColumnDef(text: string = ""): Partial<LabelProps> {
        return { text, fillRow: true };
    }
}
